export const base_path = "/";
export const img_path = "/";
export const company_short_name = "ZYVO";
export const company_address_env =
  "Vista Tower, E-302, 2nd Floor, Lakhnaur Pind Rd, Industrial Area, Sector 75, Sahibzada Ajit Singh Nagar, Punjab 160055.";
export const company_email_env = "ceo@lakheraglobalservices.com";
export const ROLE_SUPER_ADMIN = 1;
export const ROLE_ADMIN = 2;
export const ROLE_EMPLOYEE = 3;
export const ROLE_SUPER_ADMIN_CHAR = "SUPER ADMIN";
export const ROLE_ADMIN_CHAR = "ADMIN";
export const ROLE_EMPLOYEE_CHAR = "EMPLOYEE";
